import EDAvenyProgressMedium from './components/EDAvenyProgressMedium';
import EDAvenyProgressSmall from './components/EDAvenyProgressSmall';

interface IProps {
  size?: number;
  /**Defines which progressbar design you want. */
  variant?: 'small' | 'medium';
  testId?: string;
  overlay?: boolean;
}

export const EDAvenyProgress = (props: IProps) => {
  const { variant, ...rest } = props;
  if (props.variant === 'small') {
    return <EDAvenyProgressSmall testId="AvenyProgress" {...rest} />;
  } else {
    return <EDAvenyProgressMedium testId="AvenyProgress" {...rest} />;
  }
};

export default EDAvenyProgress;
